import React from "react";
import classnames from "classnames";

import { Dispensary } from "@/custom-types/Dispensary";
import { getStatusMessage } from "@/utils/dispensaryScheduleUtils";

const OpenStatus: React.FC<{ className?: string; dispensary: Dispensary }> = ({
  className,
  dispensary,
}) => {
  const storeStatusMessage = getStatusMessage(
    dispensary.preorderConfigured,
    dispensary.currentStatuses?.store,
    dispensary.timeZone,
    "store",
  );

  return (
    <div className={classnames("text-xs", className)}>
      <span data-testid="statusMessage" className="mr-xs">
        {storeStatusMessage}
      </span>
    </div>
  );
};

export default OpenStatus;
